import { RockyContext } from "../../context/context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Envs } from "../../enums/envs";

export const RockyComponentsProvider: React.FC<{
  children: React.ReactNode;
  token: string;
  env: "dev" | "local" | "prod";
}> = ({ children, token, env }) => {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <RockyContext.Provider value={{ token, env: Envs[env] }}>
        {children}
      </RockyContext.Provider>
    </QueryClientProvider>
  );
};
